import { Link } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background};
  padding: 20px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 480px;
  background: white;
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.shadow};
  padding: 28px;
  text-align: center;
`;

const HomeLink = styled(Link)`
  display: inline-block;
  margin-top: 12px;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
  text-decoration: none;
`;

export default function NotAuthorized() {
  return (
    <Wrapper>
      <Card>
        <h2>Access Denied</h2>
        <p>You do not have permission to view this page.</p>
        <HomeLink to="/">Go to Home</HomeLink>
      </Card>
    </Wrapper>
  );
}
